import React from 'react';
import { Button, Modal, ModalProps, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { isNull, isUndefined, map } from 'lodash';
import { useSelector } from 'react-redux';

import { Loading, LoadingError, RowItem, RowItemProps } from '@components/Base';
import { formatDateTime } from '@utils/datetime';
import { amountToUsd, formatPercentage } from '@utils/currency';
import { dUserName } from '@models/User';

import { selectFeaturePolicyCommissionInvoice } from './selector';

const ROW_ITEM_PROPS: RowItemProps = {
  className: 'mb-2',
  labelProps: { xs: 6, sm: 6, md: 5 },
};

const Content = () => {
  const { t } = useTranslation();
  const { invoice } = useSelector(selectFeaturePolicyCommissionInvoice);

  if (isUndefined(invoice)) return <Loading />;
  if (isNull(invoice)) return <LoadingError />;

  const {
    createdAt,
    cashFlow,
    paymentStatus,
    totalPremium,
    brokeragePercentage,
    brokerageAmount,
    totalFrontlineBrokeragePercentage,
    totalFrontlineBrokerageAmount,
    frontlineCommissions,
  } = invoice;

  return (
    <>
      <RowItem {...ROW_ITEM_PROPS} label={t('common:createdDate')} value={formatDateTime(createdAt)} />
      <RowItem {...ROW_ITEM_PROPS} label="Cash flow" value={cashFlow} />
      <RowItem {...ROW_ITEM_PROPS} label="Payment status" value={paymentStatus} />
      <RowItem {...ROW_ITEM_PROPS} label="Total premium" value={amountToUsd(totalPremium)} />
      <RowItem {...ROW_ITEM_PROPS} label="Brokerage percentage" value={formatPercentage(brokeragePercentage)} />
      <RowItem {...ROW_ITEM_PROPS} label="Brokerage amount" value={amountToUsd(brokerageAmount)} />
      <RowItem {...ROW_ITEM_PROPS} label="Total frontline brokerage percentage" value={formatPercentage(totalFrontlineBrokeragePercentage)} />
      <RowItem {...ROW_ITEM_PROPS} label="Total frontline brokerage amount" value={amountToUsd(totalFrontlineBrokerageAmount)} />
      <Table>
        <thead>
          <tr>
            <th scope="col">Frontline</th>
            <th scope="col">Brokerage Percentage</th>
            <th scope="col">Brokerage Amount</th>
          </tr>
        </thead>
        <tbody>
          {map(frontlineCommissions, ({ id, frontline, brokeragePercentage: percentage, brokerageAmount: amount }) => (
            <tr key={id}>
              <td>{dUserName(frontline)}</td>
              <td>{formatPercentage(percentage)}</td>
              <td>{amountToUsd(amount)}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  )
}


const PolicyCommissionInvoiceDetailsModal = ({ invoice, ...props }: ModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal {...props} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Invoice</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Content />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={props.onHide}>
          {t('common:close')}
        </Button>
      </Modal.Footer>
    </Modal>
  )
};

export { PolicyCommissionInvoiceDetailsModal };
